import { render } from "./Commerce.vue?vue&type=template&id=51a9099c"
import script from "./Commerce.vue?vue&type=script&lang=js"
export * from "./Commerce.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__